import { loadStripe } from '@stripe/stripe-js';

// Initialize Stripe with your publishable key
export const stripePromise = loadStripe(import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY);

// Stripe configuration
export const STRIPE_CONFIG = {
  appearance: {
    theme: 'stripe' as const,
    variables: {
      colorPrimary: '#10b981',
      colorBackground: '#ffffff',
      colorText: '#1f2937',
      colorDanger: '#ef4444',
      fontFamily: 'Inter, system-ui, sans-serif',
      spacingUnit: '4px',
      borderRadius: '8px',
    },
  },
};

// Credit package prices in cents (EUR)
export const CREDIT_PACKAGES = [
  {
    id: '550e8400-e29b-41d4-a716-446655440001',
    name: 'Basic Package',
    credits: 10,
    price: 999, // €9.99 in cents
    description: 'Perfect for small projects',
    popular: false,
  },
  {
    id: '550e8400-e29b-41d4-a716-446655440002',
    name: 'Professional Package',
    credits: 25,
    price: 1999, // €19.99 in cents
    description: 'Great for regular users',
    popular: true,
  },
  {
    id: '550e8400-e29b-41d4-a716-446655440003',
    name: 'Business Package',
    credits: 50,
    price: 3499, // €34.99 in cents
    description: 'Best value for businesses',
    popular: false,
  },
  {
    id: '550e8400-e29b-41d4-a716-446655440004',
    name: 'Enterprise Package',
    credits: 100,
    price: 5999, // €59.99 in cents
    description: 'For high-volume users',
    popular: false,
  },
];

// Helper function to format price
export const formatPrice = (priceInCents: number): string => {
  return new Intl.NumberFormat('bg-BG', {
    style: 'currency',
    currency: 'EUR',
  }).format(priceInCents / 100);
};

// Helper function to get package by ID
export const getCreditPackage = (packageId: string) => {
  return CREDIT_PACKAGES.find(pkg => pkg.id === packageId);
};
